import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const PublicReporterCard = () => {
  const { id } = useParams();
  const [reporter, setReporter] = useState(null);

  useEffect(() => {
    const fetchReporter = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/reporter/public/${id}`
        );
        setReporter(res.data.data);
      } catch (err) {
        console.error("Error fetching public reporter:", err);
      }
    };

    fetchReporter();
  }, [id]);

  if (!reporter) return <p>Loading...</p>;

  return (
    <div className="max-w-md mx-auto p-6 shadow-lg rounded-lg mt-10 bg-white text-center">
      <img src={reporter.image} alt="Reporter" className="w-40 h-40 object-cover mx-auto rounded-full" />
      <h2 className="text-2xl font-bold mt-4">{reporter.name}</h2>
      <p className="text-gray-600">{reporter.channelName}</p>
      <p className="text-sm mt-2 text-gray-500">IINSAF ID: {reporter._id}</p>
    </div>
  );
};

export default PublicReporterCard;
